'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Footer = require('@narvar/nth-bundle-narvar-footer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const DEFAULT_LOGO_HREF = 'https://corp.narvar.com/survey';
const NarvarLogoWithLink = () => {
  const {
    narvarFooter
  } = nthHookSettings.useSettings();
  const {
    logoHref
  } = narvarFooter ?? {};
  const {
    iconsFooterNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("a", {
    href: logoHref || DEFAULT_LOGO_HREF,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default["default"].createElement(Footer.NarvarLogo, {
    style: iconsFooterNone
  }));
};
var NarvarLogo = nthHookSettings.withSettingsProvider(nthHookTheme.withThemeProvider(NarvarLogoWithLink, {
  themeTokens: ['iconsFooterNone']
}), {
  settingsRequested: `
    narvarFooter {
      logoHref
    }
  `
});

exports["default"] = NarvarLogo;
